import { NgModule } from '@angular/core';
import { CurrentAccountsStrategy } from './current-account-listing.strategy';
import { SavingsAccountsStrategy } from './savings-account-listing.strategy';
import { SavingsInternalTransferFormAccountListStrategy } from './savings-internal-transfer-form-account-list.strategy';

@NgModule({
  providers: [
    CurrentAccountsStrategy,
    SavingsAccountsStrategy,
    SavingsInternalTransferFormAccountListStrategy,
  ],
})
export class AccountListingStrategiesModule {}
